"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateBrandMasterSchema = exports.createBrandMasterSchema = exports.brandMasterShape = void 0;
const zod_1 = require("zod");
exports.brandMasterShape = {
    brandCode: zod_1.z.string().min(1).max(30).optional(),
    name: zod_1.z.string().min(1).max(255),
    genericMasterId: zod_1.z.string().uuid(),
    manufacturerMasterId: zod_1.z.string().uuid().optional(),
};
exports.createBrandMasterSchema = zod_1.z.object(exports.brandMasterShape);
exports.updateBrandMasterSchema = exports.createBrandMasterSchema.partial();
//# sourceMappingURL=brand-master.schema.js.map